import { useState } from "react";

interface ShareButtonsProps {
  title: string;
}

const platforms = [
  { key: "weibo", label: "微博", icon: "ri-weibo-fill", tone: "hover:text-primary-400" },
  { key: "wechat", label: "微信", icon: "ri-wechat-fill", tone: "hover:text-secondary-400" },
  { key: "bilibili", label: "B站", icon: "ri-bilibili-fill", tone: "hover:text-accent-400" },
];

export default function ShareButtons({ title }: ShareButtonsProps) {
  const [toast, setToast] = useState("");

  const flash = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      flash("链接已复制到剪贴板");
    } catch {
      flash("复制失败，请手动复制浏览器地址栏链接");
    }
  };

  const shareTo = async (label: string) => {
    const url = window.location.href;
    const text = `${title} - 主播视频 ${url}`;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      /* ignore */
    }
    flash(`已复制分享文案，去${label}粘贴发布吧`);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={copyLink}
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 bg-background-900 px-4 py-2.5 text-sm font-semibold text-foreground-100 transition-colors hover:border-primary-500 hover:text-primary-300"
      >
        <i className="ri-link" /> 复制链接
      </button>
      {platforms.map((p) => (
        <button
          key={p.key}
          type="button"
          aria-label={`分享到${p.label}`}
          onClick={() => shareTo(p.label)}
          className={`flex h-10 w-10 items-center justify-center rounded-md border border-background-700 bg-background-900 text-foreground-300 transition-colors hover:border-background-500 ${p.tone}`}
        >
          <i className={`${p.icon} text-lg`} />
        </button>
      ))}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 rounded-md border border-background-700 bg-background-800 px-5 py-3 text-sm font-medium text-foreground-100">
          {toast}
        </div>
      )}
    </div>
  );
}